<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">In memory of</p>
<p style="text-align: center;">Matthew Curno Crane O’Reilly</p>
<p style="text-align: center;">1965–2012</p>
<p style="text-align: center;">with my love</p>
<p style="text-align: center;">(You would have enjoyed this story Maff)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?3b319700